import React from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';

const LocalizedTextField = ({ ...props }) => {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const isRTL = i18n.language === 'he';

  return (
    <TextField
      {...props}
      InputProps={{
        ...props.InputProps,
        sx: {
          textAlign: isRTL ? 'right' : 'left',
          direction: isRTL ? 'rtl' : 'ltr',
          ...(props.InputProps?.sx || {}),
        },
      }}
      InputLabelProps={{
        ...props.InputLabelProps,
        sx: {
          right: isRTL ? 14 : 'unset',
          left: isRTL ? 'unset' : 14,
          transformOrigin: isRTL ? 'right' : 'left',
          backgroundColor: theme.palette.background.paper,
          padding: '0 8px',
          ...(props.InputLabelProps?.sx || {}),
        },
      }}
    />
  );
};

export default LocalizedTextField; 